<template>
  <el-dialog
    id="SampleAddOrUpdate"
    :title="!disabled ?
    (addOrUpdateFlag ? '外送标本申请单录入' : '外送标本申请单修改'):'外送标本申请单查看'"
    :visible.sync="visible"
    :close-on-click-modal="false"
    @closed="close()">
    <el-row>
      <el-col :span="24">
        <p class="title"><i class="el-icon-edit-outline"></i>基本信息</p>
        <el-form ref="dataForm" :model="dataForm" :rules="dataRule" :inline="true" label-width="100px" size="mini">
          <el-row>
            <el-col :span="12">
              <el-form-item label="姓名" prop="realName">
                <el-input v-model="dataForm.realName" :disabled="disabled"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="身份证号" prop="cardId">
                <el-input v-model="dataForm.cardId" :disabled="disabled" @blur="calculateBirth"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="性别" prop="sex">
                <el-radio label="1" v-model="dataForm.sex" :disabled="disabled">男</el-radio>
                <el-radio label="0" v-model="dataForm.sex" :disabled="disabled">女</el-radio>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item label="出生日期" prop="birthday">
                <el-date-picker
                  v-model="dataForm.birthday"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="选择日期"
                  :disabled="disabled"
                  :editable="false"
                  :picker-options="picker_birthday">
                </el-date-picker>
              </el-form-item>
            </el-col> -->
            <el-col :span="12">
              <el-form-item label="年龄" prop="age">
                <el-input v-model.number="dataForm.age" :disabled="disabled"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="手机号" prop="mobile">
                <el-input v-model="dataForm.mobile" :disabled="disabled"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
      <el-col :span="24">
        <p class="title"><i class="el-icon-edit-outline"></i>检验信息</p>
        <el-form ref="dataForm2" :model="dataForm2" :rules="dataRule2" :inline="true" label-width="100px" size="mini">
          <el-row>
            <el-col :span="12">
              <el-form-item label="送检检验所" v-if="detailItemId">
                {{providerName}}
              </el-form-item>
              <el-form-item label="送检检验所" prop="providerId" v-else>
                <el-select v-model="dataForm2.providerId" filterable placeholder="请选择" @change="selectProvider" :disabled="disabled">
                  <el-option
                    v-for="(item,index) in options_provider"
                    :key="item.id"
                    :label="item.providerName"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="检验项目" v-if="detailItemId">
                {{itemName}}
              </el-form-item>
              <el-form-item label="检验项目" prop="itemId" v-else>
                <el-select v-model="dataForm2.itemId" filterable placeholder="请选择" @change="selectItem" :disabled="disabled">
                  <el-option
                    v-for="item in options_item"
                    :key="item.id"
                    :label="item.itemName"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="保存条件">
                {{TS}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="报告方式">
                {{reportType}}
              </el-form-item>
            </el-col>
            <template v-for="(sample, index) in dataForm2.sampleInfoList">
              <el-col :span="24" class="sample_xh">
                <span class="xh">标本{{index+1}}</span>
                <span class="dotted_line"></span>
                <i class="el-icon-delete" v-if="dataForm2.sampleInfoList.length > 1 && !disabled" @click="removeSample(index)"></i>
              </el-col>
              <!--普通用户身份录入样本（条形码可填写订单号）-->
              <el-col :span="12" v-if="detailItemId && fromPath != 'manage'">
                <el-form-item
                  label="条形码"
                  :prop="'sampleInfoList.' + index + '.hospCode'"
                  :rules="[
                  { required: true, message: '条形码不能为空,若无可填写当前订单号', trigger: 'blur' },
                  { pattern: /^([A-Za-z0-9()（）]+)$/, message: '条形码格式有误', trigger: 'blur' },
                  { max: 20, message: '长度不能超过20个字符', trigger: 'blur' },
                  ]">
                  <el-input v-model="sample.hospCode" placeholder="可填写订单号" :disabled="disabled">
                    <!--<el-button slot="append" icon="el-icon-search"></el-button>-->
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-else>
                <el-form-item
                  label="条形码"
                  :prop="'sampleInfoList.' + index + '.hospCode'"
                  :rules="[
                  { required: true, message: '条形码不能为空', trigger: 'blur' },
                  { pattern: /^([A-Za-z0-9()（）]+)$/, message: '条形码格式有误', trigger: 'blur' },
                  { max: 20, message: '长度不能超过20个字符', trigger: 'blur' },
                  ]">
                  <el-input v-model="sample.hospCode" :disabled="disabled">
                    <!--<el-button slot="append" icon="el-icon-search"></el-button>-->
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="标本类型"
                  :prop="'sampleInfoList.' + index + '.sampleType'"
                  :rules="{
                    required: true, message: '标本类型不能为空', trigger: 'change'
                  }">
                  <el-select v-model="sample.sampleType" filterable placeholder="请选择" :disabled="disabled">
                    <el-option
                      v-for="(item,index) in options_sampleType"
                      :key="index"
                      :label="item"
                      :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="测试方法"
                  :prop="'sampleInfoList.' + index + '.testMethod'"
                  :rules="{
                    required: true, message: '测试方法不能为空', trigger: 'change'
                  }">
                  <el-select v-model="sample.testMethod" filterable placeholder="请选择" :disabled="disabled">
                    <el-option
                      v-for="(item,index) in options_testMethod"
                      :key="index"
                      :label="item"
                      :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="标本数量"
                  :prop="'sampleInfoList.' + index + '.sampleNum'"
                  :rules="[
                    { pattern: /^\+?[1-9][0-9]*$/, message: '数量必须为正整数' },
                    { pattern:/^\d{1,20}$/, message: '长度不能超过20个字符', trigger: 'blur' }
                  ]">
                  <el-input v-model="sample.sampleNum" :disabled="disabled"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="采集时间"
                  :prop="'sampleInfoList.' + index + '.submitTime'">
                  <el-date-picker
                    v-model="sample.submitTime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetime"
                    placeholder="选择日期"
                    :disabled="disabled"
                    :editable="false"
                    :picker-options="{
                      disabledDate: time => {
                        return (
                          time.getTime() > new Date().getTime()
                        )
                      }
                    }">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </template>
            <el-col :span="24" class="sample_add" v-if="!disabled">
              <span class="dotted_line"></span>
              <i class="el-icon-plus" @click="addSample()"></i>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <p class="title"><i class="el-icon-edit-outline"></i>其他信息</p>
        <el-form ref="dataForm3" :model="dataForm3" :rules="dataRule3" :inline="true" label-width="100px" size="mini">
          <el-row>
            <el-col :span="12">
              <el-form-item label="送检科室">
                <template v-if="!disabled">
                  <el-select v-model="dataForm3.keshi" placeholder="请选择" :disabled="disabled">
                    <el-option
                      v-for="(item,index) in options_keshi"
                      :key="index"
                      :label="item"
                      :value="item">
                    </el-option>
                  </el-select>
                </template>
                <template v-else>
                  <el-select v-model="dataForm3.keshi" placeholder="" :disabled="disabled">
                    <el-option
                      v-for="(item,index) in options_keshi"
                      :key="index"
                      :label="item"
                      :value="item">
                    </el-option>
                  </el-select>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="病区" prop="bingqu">
                <el-input v-model="dataForm3.bingqu" :disabled="disabled"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="床号" prop="chuanghao">
                <el-input v-model="dataForm3.chuanghao" :disabled="disabled"></el-input>
              </el-form-item>
            </el-col>
            <template v-if="!disabled">
              <el-col :span="12">
                <el-form-item label="备注" prop="remark">
                  <el-input type="textarea" v-model="dataForm3.remark" :disabled="disabled"></el-input>
                </el-form-item>
              </el-col>
            </template>
            <template v-else>
              <el-col :span="12">
                <el-form-item label="备注" prop="remark">
                  {{dataForm3.remark}}
                </el-form-item>
              </el-col>
            </template>
          </el-row>
          <el-row class="border">
            <el-col :span="12">
              <el-form-item label="录入人员" prop="operator">
                <el-input v-model="dataForm3.operator" :disabled="disabled"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label=" " prop="agreeReportPerm">
                <el-checkbox v-model="dataForm3.agreeReportPerm" :disabled="disabled" v-show="dataForm3.isPromotion">同意授权您的医生查看报告</el-checkbox>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="fromPath == 'manage'">
              <el-form-item label="送检医师" prop="submitPhysician">
                <el-input v-model="dataForm3.submitPhysician" :disabled="disabled"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
    <el-row v-if="!disabled">
      <el-col :span="24" class="operate_btn">
        <template v-if="!addOrUpdateFlag">
          <el-button @click="save(2)" :loading="loading" :disabled="loading">保存修改</el-button>
        </template>
        <template v-else>
          <el-checkbox class="next" v-model="nextFlag" v-if="fromPath == 'manage'">保存并继续下一个</el-checkbox>
          <el-button type="primary" @click="save(1)" :loading="loading" :disabled="loading">保存</el-button>
        </template>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
  import axios from 'axios'

  export default {
    name: "sample-add-or-update",
    data() {
      return {
        fromPath: '',//调用来源:订单打开还是样本管理打开
        clickTag: 0,//重复保存标志
        loading: false,
        disabled: false,//只读
        visible: false,
        nextFlag: false,//是否继续录入
        providerName:'',//送检检验所
        itemName:'',//检验项目
        reportType:'无',//报告方式
        TS:'无',//运输条件
        orderId:'',//订单id
        orderNum:'',//订单编号
        detailItemId:'',//订单详情id
        itemId_:'',//项目id
        addOrUpdateFlag:true,//新增or修改,默认新增
        //基本信息
        dataForm: {
          realName:'',
          sex:'',
          cardId:'',
          birthday:'',
          mobile:'',
          age: ''
        },
        //检验信息
        dataForm2:{
          providerId:'',
          itemId:'',//暂时不能修改
          sampleInfoList:[
            {
              hospCode:'',
              sampleType:'',
              testMethod:'',
              sampleNum: '1',
              submitTime:'',
              id:''
            }
          ]
        },
        //其他信息
        dataForm3: {
          keshi:'',
          bingqu:'',
          chuanghao:'',
          remark:'',
          submitPhysician:'',
          operator:this.$store.state.user.name,
          agreeReportPerm: false,//是否同意授权报告,默认否
        },
        dataRule: {
          realName: [
            { required: true, message: '姓名不能为空', trigger: 'blur' },
            { max: 50, message: '长度不能超过50个字符', trigger: 'blur' },
            { pattern: /^([\u4e00-\u9fa5]{1,20}|[a-zA-Z\ \s]{1,20})$/, message: '姓名格式有误', trigger: 'blur' }
          ],
          sex: [
            { required: true, message: '性别不能为空', trigger: 'change' }
          ],
          cardId: [
            { pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '身份证格式有误', trigger: 'blur' }
          ],
          age: [
            { required: true, pattern: /^[1-9]\d?$|^1[0-4]\d$|^0$|^120$/, message: '年龄格式有误', trigger: 'blur' }
          ],
          // birthday: [
          //   { required: true, message: '出生日期不能为空', trigger: 'change' }
          // ],
          mobile: [
            { pattern: /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/, message: '手机号格式有误', trigger: 'blur' }
          ],
        },
        dataRule2: {
          providerId: [
            { required: true, message: '送检检验所不能为空', trigger: 'change' }
          ],
          itemId: [
            { required: true, message: '检验项目不能为空', trigger: 'change' }
          ],
        },
        dataRule3: {
          bingqu: [
            { pattern: /^([A-Za-z0-9()（）\u4e00-\u9fa5]+)$/, message: '病区格式有误', trigger: 'blur' },
            { max: 20, message: '长度不能超过20个字符', trigger: 'blur' },
          ],
          chuanghao: [
            { pattern: /^([A-Za-z0-9()（）\u4e00-\u9fa5]+)$/, message: '床号格式有误', trigger: 'blur' },
            { max: 20, message: '长度不能超过20个字符', trigger: 'blur' },
          ],
          remark: [
            { pattern: /^([A-Za-z0-9()（）\u4e00-\u9fa5]+)$/, message: '备注格式有误', trigger: 'blur' },
            { max: 100, message: '长度不能超过100个字符', trigger: 'blur' },
          ],
          operator: [
            { pattern: /^([A-Za-z0-9()（）\u4e00-\u9fa5]+)$/, message: '录入人员格式有误', trigger: 'blur' },
            { max: 10, message: '长度不能超过10个字符', trigger: 'blur' },
          ],
          submitPhysician: [
            { pattern: /^([A-Za-z0-9()（）\u4e00-\u9fa5]+)$/, message: '送检医师格式有误', trigger: 'blur' },
            { max: 10, message: '长度不能超过10个字符', trigger: 'blur' },
          ]
        },
        //出生日期选择限制
        picker_birthday: {
          disabledDate: time => {
            return (
              time.getTime() > new Date().getTime()
            )
          }
        },
        //送检科室
        options_keshi: [],
        //标本类型
        options_sampleType: [],
        //测试方法
        options_testMethod: [],
        //标本性状
        options_sampleProperties: [],
        //检验项目
        options_item: [],
        //送检检验所
        options_provider:[]
      }
    },
    computed: {
      user() {
        return this.$store.state.user;
      },
    },
    methods: {
      //初始化
      init (fromPath,detailItemId,itemId_,orderId) {

        let that = this
        this.fromPath = fromPath
        this.detailItemId = detailItemId
        this.itemId_ = itemId_
        this.orderId = orderId
        axios.all([
          axios.get('/jys/provider/ass'),
          axios.get("/jys/sample/hospSelect")
        ]).then(axios.spread(function (res1, res2) {
          // console.log('res1', res1)
          // console.log('res2', res2)
          if (res1.data.code == 0 && res2.data.code == 0) {
            that.options_provider = res1.data.list
            that.options_keshi = res2.data.keshiList
            that.options_sampleProperties = res2.data.propList
          }
        })).then(() => {
          this.visible = true
          if(this.fromPath == 'detail'){
            this.disabled = true
          }
        }).then(() => {
          if(this.detailItemId){
            //订单新增or修改
            //管理修改
            if(this.fromPath != 'manage'){
              //订单新增or修改
              this.dataRule.mobile.push({ required: true, message: '手机号不能为空', trigger: 'blur' })

              //获取样本信息
              axios.get("/jys/userSample/info/" + this.detailItemId,
              ).then(res => {
                if(res.data.code == 0){
                  // console.log('res.data', res.data)
                  if(res.data.sampleList && res.data.sampleList.length){
                    //修改样本
                    this.addOrUpdateFlag = false

                    let sample = res.data.sampleList[0]
                    this.dataForm.realName = sample.patientName
                    this.dataForm.sex = sample.patientSex+''
                    this.dataForm.cardId = sample.cardId
                    this.dataForm.birthday = sample.patientBirthday
                    this.dataForm.age = sample.patientAge
                    this.dataForm.mobile = sample.patientTel
                    this.dataForm2.itemId = sample.itemId
                    this.dataForm3.keshi = sample.keshi
                    this.dataForm3.bingqu = sample.bingqu
                    this.dataForm3.chuanghao = sample.chuanghao
                    this.dataForm3.remark = sample.remark
                    this.dataForm3.submitPhysician = sample.submitPhysician
                    this.dataForm3.operator = sample.personnel
                    this.dataForm3.agreeReportPerm = sample.agreeReportPerm == '1'?true : false

                    let ext = JSON.parse(sample.ext)
                    this.providerName = sample.providerName
                    this.itemName = sample.itemName
                    this.options_sampleType = ext.sampleType
                    this.options_testMethod = ext.testMethod
                    this.reportType = ext.reportType?(ext.reportType=='0'?'电子报告':'纸质报告'):'电子报告'
                    this.TS = ext.TS

                    let sampleList = res.data.sampleList
                    let sampleArray = []
                    for(let i = 0; i < sampleList.length;i++){
                      let sampleObj = {
                        hospCode:sampleList[i].hospCode,
                        sampleType:sampleList[i].sampleType,
                        testMethod:sampleList[i].testMethod,
                        sampleNum:sampleList[i].sampleNum,
                        submitTime:sampleList[i].submitTime,
                        id:sampleList[i].id,
                      }
                      sampleArray.push(sampleObj)
                    }
                    this.dataForm2.sampleInfoList = sampleArray

                    console.log('dataForm', this.dataForm)
                    console.log('dataForm2', this.dataForm2)
                    console.log('dataForm3', this.dataForm3)

                  }else{
                    //新增样本
                    this.addOrUpdateFlag = true

                    let that = this
                    //获取项目信息
                    axios.get("/jys/item/" + this.itemId_,
                    ).then(res => {
                      if (res.data.code == 0) {
                        that.dataForm2.itemId = that.itemId_
                        that.itemName = res.data.item.itemName
                        let ext = JSON.parse(res.data.item.ext)
                        that.options_sampleType = ext.sampleType
                        that.options_testMethod = ext.testMethod
                        that.reportType = ext.reportType?(ext.reportType=='0'?'电子报告':'纸质报告'):'电子报告'
                        that.TS = ext.TS
                        this.dataForm3.isPromotion = res.data.isPromotion == 0 ? false : true
                      }
                    })
                    //获取患者信息
                    let patient = this.$store.state.user
                    //为了解决之前账号信息只有年份升级使用，从这里开始---
                    if(patient.birthday.length < 6){
                      patient.birthday = patient.birthday + '-01-01'
                    }
                    //---从这里结束
                    that.dataForm.realName = patient.name
                    that.dataForm.sex = patient.sex+''
                    // that.dataForm.cardId = patient.cardId
                    that.dataForm.birthday = patient.birthday
                    that.dataForm.mobile = patient.mobile
                  }
                }
              });
            }else{
              //管理修改
              alert('管理修改')
            }
          }else{
            //管理新增
            alert('管理新增')
          }
        })
      },

      //选择检验所
      selectProvider (e) {
        axios.get("/jys/item/pvdItem/" + e + "/3"
        ).then((res) => {
          if(res.data.code == 0){
            this.options_item = res.data.list
          }
        })
      },

      //选择检验项目
      selectItem (e) {
        let that = this
        let itemList = this.options_item
        for (let i = 0; i < itemList.length; i++) {
          if(e === itemList[i].id){
            let ext = JSON.parse(itemList[i].ext)
            that.options_sampleType = ext.sampleType
            that.options_testMethod = ext.testMethod
            that.reportType = ext.reportType?(ext.reportType=='0'?'电子报告':'纸质报告'):'电子报告'
            that.TS = ext.TS
          }
        }
      },

      //新增标本
      addSample() {
        this.dataForm2.sampleInfoList.push({
          hospCode:'',
          sampleType:'',
          testMethod:'',
          sampleNum:'',
          submitTime:'',
          id:''
        });
      },

      //删除标本
      removeSample(index) {
        this.dataForm2.sampleInfoList.splice(index, 1)
      },

      //保存
      save (type) {

        let that = this
        if (this.clickTag == 0) {
          that.clickTag = 1
          that.loading = true
          setTimeout(function () {
            that.clickTag = 0
            that.loading = false
          }, 2000)
          this.$refs['dataForm'].validate((valid) => {
            this.$refs['dataForm2'].validate((valid2) => {
              this.$refs['dataForm3'].validate((valid3) => {
                if (valid && valid2 && valid3) {
                  let url = ''
                  if (this.detailItemId) {
                    //订单新增or修改
                    //管理修改
                    if (this.fromPath != 'manage') {
                      //订单新增or修改
                      if (type == 2) {
                        url = '/jys/userSample/update'
                      } else {
                        url = '/jys/userSample/save'
                      }
                    } else {
                      //管理修改
                      url = '/jys/sample/updateHosp'
                    }
                    this.dataForm2.detailItemId = this.detailItemId
                  } else {
                    //管理新增
                    url = '/jys/sample/saveHosp'
                  }
                  let saveFrom = this.deepClone(Object.assign(this.dataForm, this.dataForm2, this.dataForm3))
                  saveFrom.agreeReportPerm = this.dataForm3.agreeReportPerm ? '1' : '0'
                  axios.post(url, saveFrom
                  ).then((res) => {
                    this.$emit('refreshDataList')
                    if (res.data.code == 0) {
                      this.$alert('保存标本信息成功', '提示', {
                        confirmButtonText: '确定',
                        showClose: false,
                        callback: action => {
                          if (!this.nextFlag) {
                            //不继续录入
                            this.visible = false
                            this.close()
                            if (this.fromPath != 'manage') {
                              this.$router.push({
                                path: '/mine/sampleResult',
                                query: {orderId: this.orderId, detailItemId: this.detailItemId, itemId: this.itemId_}
                              })
                            }
                          } else {
                            //继续录入
                            this.reset()
                          }
                        }
                      });
                    } else {
                      this.$message.error({
                        dangerouslyUseHTMLString: true,
                        message: res.data.msg
                      })
                    }
                  })
                }
              })
            })
          })
        }
        else{
          this.$message({
            showClose: true,
            message: '请勿重复操作！',
            type: 'warning'
          })
        }
      },

      //重置，将其值重置为初始值并移除校验结果
      reset(){
        this.dataForm2.sampleInfoList = [
          {
            hospCode:'',
            sampleType:'',
            testMethod:'',
            sampleNum:'',
            submitTime:'',
            id:''
          }
        ]
        this.$refs['dataForm'].resetFields()
        this.$refs['dataForm3'].resetFields()
      },

      close(){
        this.dataForm2.sampleInfoList = [
          {
            hospCode:'',
            sampleType:'',
            testMethod:'',
            sampleNum:'',
            submitTime:'',
            id:''
          }
        ]
        this.$refs['dataForm'].resetFields()
        this.$refs['dataForm2'].resetFields()
        this.$refs['dataForm3'].resetFields()
        this.dataForm3.keshi = ''
        this.reportType = '无'
        this.TS = '无'
        this.$emit('refreshDataList')
      },

      //深拷贝
      deepClone(obj) {
        let _obj = JSON.stringify(obj);
        return JSON.parse(_obj)
      },

      //根据身份证号计算生日
      calculateBirth(){
        this.$refs['dataForm'].validateField('cardId',(valid) => {
          if(valid === ''){
            let idCard = this.dataForm.cardId
            let birthday = ''
            if (idCard !== null && idCard !== '') {
              if (idCard.length === 15) {
                birthday = '19' + idCard.substr(6, 6)
              } else if (idCard.length === 18) {
                birthday = idCard.substr(6, 8)
              }
              birthday = birthday.replace(/(.{4})(.{2})/, '$1-$2-')
            }
            this.dataForm.birthday = birthday
          }
        })
      }
    }
  }
</script>

<style scoped>
  #SampleAddOrUpdate >>> .el-dialog__header{
    text-align: center;
  }
  #SampleAddOrUpdate >>> .el-dialog__title{
    color: #000000;
    font-size: 17px;
    font-weight: bold;
  }
  #SampleAddOrUpdate .el-row{
    margin-bottom: 0;
  }
  .title{
    color: #93A2B7;
    margin-bottom: 15px;
  }
  .el-icon-edit-outline{
    padding-right: 5px;
  }
  .el-form >>> .el-row{
    margin-bottom: 0;
  }
  .el-form-item,
  .el-select,
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner{
    width: 100%;
  }
  .el-form-item >>> .el-form-item__label{
    font-weight: bold;
  }
  .el-form-item >>> .el-form-item__content{
    width: 50%;
  }
  .el-form-item >>> .el-input__inner{
    border-color: #D4D4D4;
    padding-left: 10px;
  }
  .el-form-item >>> .el-input-group__append{
    color: #ffffff;
    background-color: #00C5B0;
    border-color: #00C5B0;
    padding: 0 15px;
  }
  .el-form-item >>> .el-input.is-disabled .el-input__inner{
    color: #000;
    background-color: #ffffff;
    border: none;
  }
  .el-form-item >>> .el-input.is-disabled .el-input__suffix{
    display: none;
  }
  .el-form-item >>> .el-input--prefix .el-input__inner{
    padding-left: 30px;
  }
  .el-form-item >>> .el-textarea__inner{
    padding: 5px 10px;
  }
  .operate_btn{
    text-align: center;
  }
  .next{
    margin-right: 15px;
  }
  .border{
    padding-top: 25px;
    border-top:1px solid #D4D4D4;
  }
  /*标本序号*/
  .sample_xh{
    line-height: 30px;
    height: 30px;
  }
  .xh{
    width: 50px;
    float: left;
    font-size: 12px;
    color: #93A2B7;
  }
  .sample_xh .dotted_line{
    width: calc(100% - 80px);
    float: left;
    margin: 14px 5px 0 5px;
    border-bottom: 1px dashed #93A2B7;
  }
  .sample_xh .el-icon-delete{
    cursor: pointer;
    width: 20px;
    text-align: right;
  }
  /*标本新增*/
  .sample_add{
    margin-bottom: 15px;
  }
  .sample_add .dotted_line{
    width: 100%;
    float: left;
    border-bottom: 1px dashed #93A2B7;
    margin-bottom: 15px;
  }
  .sample_add .el-icon-plus{
    cursor: pointer;
    padding: 6px;
    background-color: #00C5B0;
    color: #ffffff;
    margin-left: 100px;
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    /deep/ .el-dialog {
      width: 98%!important;
    }

    /deep/ .el-dialog__body {
      padding: 10px;
    }

    /deep/ .el-row {
      display: flex;
      flex-flow: column;
    }

    /deep/ .el-col-12 {
      width: 100%;
    }

    /deep/ .el-date-editor.el-input {
      width: 100%;
    }

    /deep/ .el-input--small {
      font-size: 14px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/sample-add-or-update.vue